<div class="section">
	<div class="skip-offer-container right" (click)="openFreeReport()">
		<span class="skip-offer-text">
			Skip Offer and View Free Report
		</span>
		<mat-icon svgIcon="export"></mat-icon>
	</div>
	<div class="rings-gfx">
		<img width="auto" height="100%" src="/assets/images/rings-gfx.png" alt="">
	</div>
	<div class="congrats">
		🎉🎉 Congratulations on completing the assessment! 🎉🎉
	</div>
	<div class="top-3-heading">
		Here are your top 3 strengths:
	</div>

	<div class="top-3-strengths">
		<div class="strength secondary">
			<div class="type">
				Secondary Strength
			</div>
			<div [class]="['card', 'ca-bg-light2-color-'+secondary]">
				<div class="heading">
					<img class="ca-archetype-strength-img" [src]="'/assets/images/character-strengths/'+ secondary + '.png'"
						alt="">
					<span>
						{{secondary}}
					</span>
				</div>
				<div class="content ">
					<div class="locked">
						<img src="/assets/images/locked.png" alt="Locked">
					</div>
					<div class="blurred">
						As someone who naturally feels connection to the deeper questions and mysteries of life
						As someone who naturally feels connection to the deeper questions and mysteries of life
						As someone who naturally feels connection to the deeper questions and mysteries of life
						As someone who naturally feels connection to the deeper questions and mysteries of life
					</div>
				</div>
			</div>
		</div>
		<div class="strength primary">
			<div class="type">
				Primary Strength
			</div>
			<div [class]="['card', 'ca-bg-light2-color-'+primary]">
				<div class="heading">
					<img class="ca-archetype-strength-img" [src]="'/assets/images/character-strengths/'+ primary + '.png'" alt="">
					<span>
						{{primary}}
					</span>
				</div>
				<div class="content">
					{{ARCHETYPES[primary]?.qualitiesOrPotential?.description}}
				</div>
			</div>
		</div>
		<div class="strength tertiary">
			<div class="type">
				Tertiary Strength
			</div>
			<div [class]="['card', 'ca-bg-light2-color-'+tertiary]">
				<div class="heading">
					<img class="ca-archetype-strength-img" [src]="'/assets/images/character-strengths/'+ tertiary + '.png'"
						alt="">
					<span>
						{{tertiary}}
					</span>
				</div>
				<div class="content ">
					<div class="locked">
						<img src="/assets/images/locked.png" alt="Locked">
					</div>
					<div class="blurred">
						As someone who naturally feels connection to the deeper questions and mysteries of life
						As someone who naturally feels connection to the deeper questions and mysteries of life
						As someone who naturally feels connection to the deeper questions and mysteries of life
						As someone who naturally feels connection to the deeper questions and mysteries of life
					</div>
				</div>
			</div>
		</div>
	</div>
	<br><br>
	<div class="action-text">
		UNLOCK THE FULL POWER OF <br>
		<span class="green">{{primary}} AND YOUR OTHER STRENGTHS </span><br>
		WITH THIS LIMITED ONE-TIME OFFER!
	</div>
	<br>
	<br>

	<div class="buy-container">
		<div class="bg gradient-bg"></div>
		<div class="bg pattern-bg low-opacity"></div>
		<div class="buy-content">



			<div class="heading">
				30-min Character Coaching Session
			</div>
			<div class="sub-heading">
				+ full report
			</div>
			<div class="price">
				<span class="current">
					$59
				</span>
				<span class="slashed">
					$149
				</span>
			</div>
			<div class="footer">
				<button class="bookbtn" (click)="bookNow('CHARAMETRICS_OTO')">BOOK NOW</button>
			</div>
		</div>
	</div>
	<br> <br>
	<div class="skip-offer-container " (click)="openFreeReport()">
		<span class="skip-offer-text">
			Skip Offer and View Free Report
		</span>
		<mat-icon svgIcon="export"></mat-icon>
	</div>
	<br> <br>
	<div class="content1">
		Do you want the
		<span class="green "> clarity, confidence, and direction </span> to live <br>
		in alignment with you strengths, and let them guide your <br>
		choices, relationships, career, and personal development?
	</div>
	<br>
	<div class="info-card">
		<div class="side-image">
			<img width="100%" height="100%" src="/assets/images/image-1.png" alt="">
		</div>
		<div class="content">
			<div class="item">
				<div class="icon">
					<img width="100%" height="100%" src="/assets/images/briefcase.png" alt="">
				</div>
				<div class="item-content">
					<div class="item-heading">
						CAREER & SECURITY
					</div>
					<div class="item-body">
						Discover how to leverage your strengths for professional success, financial stability, and creating an
						environment where you thrive.
					</div>
				</div>
			</div>
			<div class="item">
				<div class="icon">
					<img width="100%" height="100%" src="/assets/images/profile-2user.png" alt="">
				</div>
				<div class="item-content">
					<div class="item-heading">
						Relationships
					</div>
					<div class="item-body">
						Learn how your strengths can build deeper connections with family, friends, and loved ones while identifying
						and overcoming relationship challenges.
					</div>
				</div>
			</div>
			<div class="item">
				<div class="icon">
					<img width="100%" height="100%" src="/assets/images/favorite-chart.png" alt="">
				</div>
				<div class="item-content">
					<div class="item-heading">
						GROWTH
					</div>
					<div class="item-body">
						Unlock strategies for personal and spiritual development, professional growth, and finding fulfilment in
						everything you do.
					</div>
				</div>
			</div>
			<div class="item">
				<div class="icon">
					<img width="100%" height="100%" src="/assets/images/heart-circle.png" alt="">
				</div>
				<div class="item-content">
					<div class="item-heading">
						WELLBEING
					</div>
					<div class="item-body">
						Explore how your strengths can lead to a balanced, healthy lifestyle—both physically and mentally—by making
						time for adventure, recreation, and self-care.
					</div>
				</div>
			</div>
		</div>
	</div>
	<br><br>
	<div class="testimony">
		<div class="profile-img">
			<img width="100%" height="100%" src="/assets/images/angela-ha.png" alt="Angela Ha Profile">
		</div>
		<br>
		<div class="testimony-content">
			“I recently
			received an unpacking of my Character Archetypes Profile with ShareTree. I love that my profile analysis was
			tailored to my stage of life, providing me with depth and insight that extends within. I believe it is an
			invaluable tool and highly recommend it to those who are invested in their personal growth. It has brought me
			self-awareness that further translates to my professional development.”
		</div>
		<br>
		<div class="name">
			<span class="user-name">Angela Ha</span> - PhysioTherapist
		</div>
	</div>
	<div class="bar"></div>
	<div class="ecard">
		<div class="bg pattern-bg "></div>
		<div class="ecard-content">
			<div class="icon">
				<img src="/assets/images/briefcase.png" width="100%" height="100%" alt="">
			</div>

			<div class="title">
				Are you looking to take your
				<span class="text-color">career to the next level</span>, aligned to your strengths and purpose?
			</div>
			<div class="content">
				We'll dive deep into your unique strengths and how to leverage them for new career opportunities. You'll get a
				personalised strategy for identifying the roles and environments where you naturally thrive, and we'll map out
				exactly how to position yourself for success. Whether it's landing that dream job or advancing where you are,
				you'll leave with the clarity and action plan to make it happen.
			</div>
		</div>
	</div>
	<div class="ecard">
		<div class="bg pattern-bg "></div>
		<div class="ecard-content">
			<div class="icon">
				<img src="/assets/images/profile-2user.png" width="100%" height="100%" alt="">
			</div>
			<div class="title">
				Do you want <span class="text-color">deeper authentic connection in your relationships</span> and
				improved communication, avoiding conflict and frustration?
			</div>
			<div class="content">
				We'll dive deep into your unique strengths and how to leverage them for new career opportunities. You'll get a
				personalised strategy for identifying the roles and environments where you naturally thrive, and we'll map out
				exactly how to position yourself for success. Whether it's landing that dream job or advancing where you are,
				you'll leave with the clarity and action plan to make it happen.
			</div>
		</div>
	</div>
	<div class="ecard">
		<div class="bg pattern-bg "></div>
		<div class="ecard-content">
			<div class="icon">
				<img src="/assets/images/favorite-chart.png" width="100%" height="100%" alt="">
			</div>
			<div class="title">
				What if you had a <span class="text-color">step-by-step strategy to grow into the best
					version</span> of yourself, and it only took a few simple tweaks to get started?
			</div>
			<div class="content">
				We'll
				focus on using your strengths to break through barriers and reach the next level of your potential. You'll
				discover simple, actionable steps to accelerate your growth in ways that make your strengths thrive. Imagine
				having a clear, step-by-step plan that helps you become the person you've always wanted to be.
			</div>
		</div>
	</div>

	<div class="bar"></div>
	<div class="testimony">
		<div class="profile-img">
			<img src="/assets/images/Areeba-reusch.png" alt="Areeba reusch Profile">
		</div>
		<br>
		<div class="testimony-content">
			“I completed this session as part of my job hunting process and found that it not only helped me back my skills
			with Charametrics data but also it gave me a lot of confidence in myself. I found ShareTree really understood
			what my goals were and helped me get a deeper understanding of how my character allows me to have the skills
			needed to succeed in my particular role but also ways in which I can improve. All in all a great experience that
			I would recommend others to try especially those who are job hunting. :)”
		</div>
		<br>
		<div class="name">
			<span class="user-name">AReeBA Reusch</span> - Executive Assistant
		</div>
	</div>
	<br>
	<br>

	<div class="cards">
		<div class="card">
			<div class="card-title">
				Free
			</div>
			<div class="card-subtitle">
				One Strength
				Report
			</div>
			<div class="description">
				For curious people wanting to discover their character
				strengths.
			</div>
			<div class="coverages">

				<div class="coverage">
					<mat-icon svgIcon="tick_circle"></mat-icon>
					Primary Strength
				</div>
				<div class="coverage">
					<mat-icon svgIcon="tick_circle"></mat-icon> Primary strength Archetype Video
				</div>
				<div class="coverage">
					<mat-icon svgIcon="tick_circle"></mat-icon>360 Feedback on Trust Dynamics
				</div>
			</div>
			<button class="action-btn" (click)="openFreeReport()">
				View Report
			</button>
		</div>
		<div class="card oto">
			<div class="offer">
				80% OFF
			</div>
			<div class="bg gradient-bg"></div>
			<div class="bg pattern-bg low-opacity"></div>
			<div class="card-content">
				<div class="card-title">
					<div class="price">
						<span class="current">
							$59
						</span>
						<span class="slashed">
							$149
						</span>
					</div>
				</div>
				<div class="card-subtitle">
					30 min Character Coaching Session
				</div>
				<div class="description">
					Talk to a <b>Certified Character Coach</b> to find out how your strengths will impact
					your selected area of growth.
				</div>
				<div class="coverages">
					<div class="coverage">
						<mat-icon svgIcon="tick_circle"></mat-icon> 30 min Coaching Session
					</div>
					<div class="coverage">
						<mat-icon svgIcon="tick_circle"></mat-icon> Full Strengths Report
					</div>
					<div class="coverage">
						<mat-icon svgIcon="tick_circle"></mat-icon> Tailored Growth Strategy
					</div>
					<div class="coverage">
						<mat-icon svgIcon="tick_circle"></mat-icon> Full 360 Tool and strength validation report.
					</div>
					<div class="coverage">
						<mat-icon svgIcon="tick_circle"></mat-icon> Deep AI Report with summary and action plan.
					</div>
				</div>
				<button class="action-btn" (click)="bookNow('CHARAMETRICS_OTO')">
					Select
				</button>
			</div>
		</div>
		<div class="card">
			<div class="card-title">
				$299
			</div>
			<div class="card-subtitle">
				60 min Character
				Coaching Session.
			</div>
			<div class="description">
				Talk to a <b>Certified Character Coach</b> to find out how your
				strengths will impact your selected area of growth.
			</div>
			<div class="coverages">
				<div class="coverage">
					<mat-icon svgIcon="tick_circle"></mat-icon>60 min Coaching Session
				</div>
				<div class="coverage">
					<mat-icon svgIcon="tick_circle"></mat-icon>Full Strengths Report
				</div>
				<div class="coverage">
					<mat-icon svgIcon="tick_circle"></mat-icon>Tailored Growth Strategy
				</div>
				<div class="coverage">
					<mat-icon svgIcon="tick_circle"></mat-icon>Full 360 Tool and strength validation report.
				</div>
				<div class="coverage">
					<mat-icon svgIcon="tick_circle"></mat-icon>Deep AI Report with summary and action plan
				</div>
				<div class="coverage">
					<mat-icon svgIcon="tick_circle"></mat-icon>Top 5 Job Roles and Team Dynamics
				</div>
			</div>
			<button class="action-btn" (click)="bookNow('CHARACTER_COACHING_SESSION_60MIN')">
				Select
			</button>
		</div>
	</div>
	<div class="page-footer">
		<span class="text-color">With this offer,</span> we are hoping that you can contribute to further feedback and leave
		us a google review.
	</div>
